export default __webpack_public_path__ + "static/media/upload-Image-thumnail.ee134906.svg";